import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { FeatureContentItem } from './index';
import { CroppedImage } from '@weee-fe/module';

interface MediaImageProps {
  item: FeatureContentItem;
  width?: number;
  className?: string;
  wrapperClassName?: string;
}

const MediaImage: React.FC<MediaImageProps> = ({ item, width, className, wrapperClassName }) => {
  const { mobile_media } = item;

  if (!mobile_media) return <></>;
  return (
    <CroppedImage
      url={mobile_media}
      configs={
        width
          ? {
              renderWidth: width * 2
            }
          : {}
      }
      wrapperClassName={twMerge(
        'border border-solid border-tint-black-100 bg-[#ffffff] rounded-400 overflow-hidden',
        wrapperClassName
      )}
      loadingPlaceholderClassName="bg-[#ffffff]"
      className={twMerge('w-full h-full object-cover', className)}
      alt=""
      aria-hidden="true"
    />
  );
};

export default MediaImage;
